module.exports = __webpack_public_path__ + "img/brochure-promo-bg.68846a6.jpg";